/* Countdown fuer den Birthday Sale.

   Drei Zustaende, die das Skript selbst erkennt – die Seite muss nicht
   umgestellt werden, wenn die Aktion startet oder endet:
     vor dem Start   zaehlt auf den Startzeitpunkt, Label "Start in"
     waehrend        zaehlt auf das Ende, Label "Aktion endet in",
                     zusaetzlich Klasse lrb-cd--live fuer den pulsenden Punkt
     danach          blendet die Uhr aus und zeigt den Schlusstext

   Die Leiste darunter zeigt immer Start UND Ende. Ihr Fortschrittsbalken ist
   vor dem Start leer, waehrend der Aktion anteilig gefuellt und danach voll.
   Deshalb braucht es keine zweite Uhr fuer die Restlaufzeit.

   ZEITZONE: Die Zeitpunkte kommen als ISO-String MIT Offset aus dem Liquid
   (z. B. 2026-09-11T00:01:00+0200). Ohne Offset wuerde jedes Geraet die Zeit in
   seiner eigenen Zone interpretieren – ein Kunde in Wien saehe dann eine
   andere Restzeit als einer in Berlin.

   Kein Flackern beim Laden: Die Startwerte stehen bereits im HTML, das Skript
   ueberschreibt sie nur. */
(function () {
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function init(root) {
    if (root.dataset.lrBdayReady) return;
    root.dataset.lrBdayReady = '1';

    var start = Date.parse(root.dataset.start);
    var end = Date.parse(root.dataset.end);
    if (isNaN(start) || isNaN(end)) return;

    var label = root.querySelector('[data-lr-cd-label]');
    var box = root.querySelector('[data-lr-cd-grid]');
    var fill = root.querySelector('[data-lr-cd-fill]');
    var out = {
      d: root.querySelector('[data-lr-cd="d"]'),
      h: root.querySelector('[data-lr-cd="h"]'),
      m: root.querySelector('[data-lr-cd="m"]'),
      s: root.querySelector('[data-lr-cd="s"]')
    };
    var txtBefore = root.dataset.labelBefore || 'Start in';
    var txtRunning = root.dataset.labelRunning || 'Aktion endet in';

    function setFill(pct) {
      if (fill) fill.style.width = pct + '%';
    }

    function tick() {
      var now = Date.now();
      var target, text;

      if (now < start) {
        target = start;
        text = txtBefore;
        root.classList.remove('lrb-cd--live');
        setFill(0);
      } else if (now < end) {
        target = end;
        text = txtRunning;
        root.classList.add('lrb-cd--live');
        setFill(Math.min(100, Math.max(0, ((now - start) / (end - start)) * 100)));
      } else {
        root.classList.add('lrb-cd--over');
        root.classList.remove('lrb-cd--live');
        setFill(100);
        if (label) label.textContent = '';
        clearInterval(timer);
        return;
      }

      root.classList.remove('lrb-cd--over');
      if (label && label.textContent !== text) label.textContent = text;

      var left = Math.max(0, target - now);
      var sec = Math.floor(left / 1000);
      var d = Math.floor(sec / 86400);
      var h = Math.floor((sec % 86400) / 3600);
      var m = Math.floor((sec % 3600) / 60);
      var s = sec % 60;

      if (out.d) out.d.textContent = String(d);
      if (out.h) out.h.textContent = pad(h);
      if (out.m) out.m.textContent = pad(m);
      if (out.s) out.s.textContent = pad(s);
      if (box) box.setAttribute('aria-label', d + ' Tage, ' + h + ' Stunden, ' + m + ' Minuten verbleibend');
    }

    var timer = setInterval(tick, 1000);
    tick();
  }

  function boot() {
    var all = document.querySelectorAll('[data-lr-countdown]');
    for (var i = 0; i < all.length; i++) init(all[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
